import StockSubsectionPlaceholder from "../../../components/StockSubsectionPlaceholder";

export default function DesviosPage() {
  return (
    <StockSubsectionPlaceholder
      sectionPath="analisis"
      subsectionPath="desvios"
    />
  );
}
